export const bidPricingInformationAdditionalInfo = [
    "איש קשר לקבלת ההזמנה - יש לוודא שהפרטים תקינים ומדויקים. מומלץ לשים איש קשר נוסף למקרה הצורך שיהיה זמין בעת ביום האספקה.",
    "משלוח ללא מענה - בעת קבלת המשלוח במידה ואיש הקשר אינו זמין, המשלוח יושאר בכתובת המצוינת. במידה ולא ניתן להשאיר את המשלוח, השליח ייקח אותה חזרה, ותחוייבו על ההזמנה במלואה.",
    "זמן אספקה - זמן האספקה הוא בטווח של שעתיים, בחגים ייתכנו עיכובים קלים בזמני השילוח. אנו מציעים לקחת בחשבון זמן נוסף ולהיות סבלניים."
];
